import { render, staticRenderFns } from "./VAvatarUploader.vue?vue&type=template&id=536e530c&"
import script from "./VAvatarUploader.vue?vue&type=script&lang=js&"
export * from "./VAvatarUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports